import Cookies from "js-cookie";
import QueryString from 'query-string';

/**
 * 记录登录
 */
export function setLogin() {
  Cookies.set('is_login', 1, { expires: 7 });
}

/**
 * 判断是否登录
 */
export function isLogin() {
  return Cookies.get('is_login') === '1';
}

/**
 * 清除登录状态
 */
export function clearLogin() {
  Cookies.remove('is_login');
  Cookies.remove('token');
  clearWXUnionid();
}

/**
 * 存储 token
 * @param {string} token (bearer 开头)
 */
export function setToken(token) {
  if (token) {
    Cookies.set('token', token, { expires: 7 });
  }
}

export function setSignToken(signToken) {
  if (signToken) {
    Cookies.set('signToken', signToken, { expires: 1 });
  }
}

export function getSignToken() {
  return Cookies.get('signToken') || null;
}

export function clearSignToken() {
  Cookies.remove('signToken');
}

export function getPreviewAuth() {
  return QueryString.parse(window.location.search)?.previewAuth || null;
}

/**
 * 获取 token
 */
export function getToken() {
  return Cookies.get('token') || null;
}

/**
 * 存储云闪付 openid
 */
export function setYSFOpenid(openid) {
  Cookies.set('YSF_OPENID', openid);
}

/**
 * 获取云闪付 openid
 */
export function getYSFOpenid() {
  return Cookies.get('YSF_OPENID') || null;
}

/**
 * 清除云闪付 openid
 */
export function clearYSFOpenid() {
  Cookies.remove('YSF_OPENID');
}

/**
 * 存储微信 openid
 */
export function setWXOpenid(openid) {
  Cookies.set('WX_OPENID', openid);
}

/**
 * 获取微信 openid
 */
export function getWXOpenid() {
  return Cookies.get('WX_OPENID') || null;
}

/**
 * 清除微信 openid
 */
export function clearWXOpenid() {
  Cookies.remove('WX_OPENID');
}

/**
 * 存储微信 unionid
 */
export function setWXUnionid(unionid) {
  Cookies.set('WX_UNIONID', unionid);
}

/**
 * 获取微信 unionid
 */
export function getWXUnionid() {
  return Cookies.get('WX_UNIONID') || null;
}

/**
 * 清除微信 unionid
 */
export function clearWXUnionid() {
  Cookies.remove('WX_UNIONID');
}

/**
 * 存储微信 language
 */
export function setWXLanguage(language) {
  Cookies.set('WX_LANGUAGE', language);
}

/**
 * 获取微信 language
 */
export function getWXLanguage() {
  return Cookies.get('WX_LANGUAGE') || 'en';
}

/**
 * 生成uuid 
 */
export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-mixed-operators
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
};

/**
 * 获取用户uuid
 */
export function getUUid() {
  // 首先判断是否存在uuid
  let uuid = Cookies.get('SHOP_UUID');
  if (!uuid) {
    uuid = generateUUID();
    Cookies.set('SHOP_UUID', uuid);
  }
  return uuid;
}

/**
 * 企微token
 */
export function setExamToken(examToken) {
  if (examToken) {
    Cookies.set('examToken', examToken, { expires: 6 });
  }
}

export function getExamToken() {
  return Cookies.get('examToken') || null;
}

export function clearExamoken() {
  Cookies.remove('examToken');
}

/**
 * 企微token-调休
 */
export function setAdjustLeaveToken(adjustLeaveToken) {
  if (adjustLeaveToken) {
    Cookies.set('adjustLeaveToken', adjustLeaveToken, { expires: 6 });
  }
}

export function getAdjustLeaveToken() {
  return Cookies.get('adjustLeaveToken') || null;
}

export function clearAdjustLeaveToken() {
  Cookies.remove('adjustLeaveToken');
}

/**
 * 记录登录以后的回跳地址
 * @param {string} url 回跳地址
 */
export function setLoginRedirect(url) {
  sessionStorage.setItem('login_redirect', url);
}

/**
 * 获取登录以后的回跳地址
 */
export function getLoginRedirect() {
  return sessionStorage.getItem('login_redirect') || null;
}

/**
 * 清除登录以后的回跳地址
 */
export function clearLoginRedirect() {
  sessionStorage.removeItem('login_redirect');
}

/**
 * 企微人事助手-用户信息
 */
export function setWxUserInfo(info) {
  if (info) {
    Cookies.set('wxUserInfo', info, { expires: 6 });
  }
}

export function getWxUserInfo() {
  return Cookies.get('wxUserInfo') || null;
}

export function clearWxUserInfo() {
  Cookies.remove('wxUserInfo');
}